<div [ngClass]="currentTheme">
    <div class="page" [ngClass]="{'dtp-buffer':headerData.show_dtp}">
      <router-outlet></router-outlet>
    </div>
</div>
